export default __webpack_public_path__ + "static/media/Filter_Icon_Icon.fde0684a.svg";